import { useState, useEffect } from "react";
import { FormTemplate, FormSection } from "../types/forms";
import { getFormByUuid } from "../services/consultationform";

const mapSectionType = (section: FormSection): FormSection => {
  if (section.type) return section;

  const templateIdMap: Record<number, FormSection["type"]> = {
    1: "contact",
    2: "medical",
    3: "marketing",
    4: "question",
    5: "heading",
    6: "text",
    7: "policy",
    8: "disclaimer",
  };

  return {
    ...section,
    type: section.form_template_id ? templateIdMap[section.form_template_id] || null : null
  };
};

export function useFormBuilder(UUid: string) {
  const [templateState, setTemplateState] = useState<FormTemplate>({
    uuid: UUid,
    id: "",
    title: "Untitled Form",
    description: "Provide a brief description for your form.",
    services: [],
    sections: [],
    fields: [],
    userId: "",
    saved: false,
    draft: true,
  });

  const [activeView, setActiveView] = useState<"editor" | "preview">("editor");
  const [currentSection, setCurrentSection] = useState(0);

  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    if (!UUid) return;

    const fetchTemplate = async () => {
      setLoading(true);
      setError(null);

      try {
        console.log("-----------------aaaaaaaaaaaaaaaaaaa", UUid);
        const result = await getFormByUuid(UUid);

        // Map BE response to FormTemplate
        const form = result?.form;
        console.log("THE FORM IS ", form);
        if (!form) throw new Error("Invalid form response from server.");

        setTemplateState({
          uuid: form.uuid || UUid,
          id: String(form.id || ""),
          title: form.title || "Untitled Form",
          description: form.description || "",
          services: (form.business_services || []).map((s: any) => ({
            ...s,
            title: s.name,
          })),
          sunbeds: form.sunbeds || [],
          sections: (form.sections || [])
            .map((s: FormSection) => {
              const mapped = mapSectionType(s);
              const sortedFields = (s.fields || []).sort((a: any, b: any) => (a.order || 0) - (b.order || 0));
              let sectionTitle = s.title ?? null;
              if ((mapped.type === "text" || mapped.type === "heading") && !sectionTitle?.trim() && sortedFields.length > 0) {
                const first = sortedFields[0];
                if (typeof first.options === "string" && first.options.trim()) {
                  sectionTitle = first.options.trim();
                } else if (first.label?.trim()) {
                  sectionTitle = first.label.trim();
                } else if (first.options && typeof first.options === "object" && first.options !== null && "content" in first.options) {
                  const opts = first.options as { content?: string };
                  if (opts.content?.trim()) sectionTitle = opts.content.trim();
                }
              }
              return {
                ...mapped,
                title: sectionTitle,
                fields: sortedFields,
              };
            })
            .sort((a: any, b: any) => (a.order || 0) - (b.order || 0)),
          fields: [],
          userId: String(form.company_id || ""),
          saved: true,
          draft: form.status === "draft",
        });
        console.log("TEMPLATE STATE ", templateState);
      } catch (err: any) {
        console.error("Error fetching form by UUID:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplate();
  }, [UUid]);

  return {
    templateState,
    setTemplateState,
    activeView,
    setActiveView,
    currentSection,
    setCurrentSection,
    loading,
    error,
  };
}
